// extracted by mini-css-extract-plugin
export default {"backgroundBlue":"BlueBackground_backgroundBlue__NEOEw","theme-default":"BlueBackground_theme-default__bzzsb","theme-visa":"BlueBackground_theme-visa__lpoun"};